export const baseUrl = "/strapi/api";

export const imagePrefixUrl = "/strapi";
